import { call, put, select } from 'redux-saga/effects';
import { iActionListAclFiltered } from 'domain/interfaces/redux/org/listAclFiltered';
import { ListOrgAclFiltered } from 'domain/usecases/org/remote/ListOrgAclFiltered';
import { makeRemoteListOrgAclFiltered } from 'main/factories/usecases/org/ListOrgAclFilteredFactory';
import {
  listAclFilteredSuccess,
  listAclFilteredFailed,
} from 'data/store/reducer/org/actions/listAclFiltered';

export function* onListAclFiltered(action: iActionListAclFiltered) {
  const remoteListOrgAclFiltered = makeRemoteListOrgAclFiltered();

  try {
    const response: ListOrgAclFiltered.Model = yield call(
      remoteListOrgAclFiltered.list,
      action.payload,
    );
    yield put(
      listAclFilteredSuccess({
        ...response,
      }),
    );
  } catch (e) {
    yield put(listAclFilteredFailed());
  }
}

// eslint-disable-next-line @typescript-eslint/no-empty-function
export function onListAclFilteredSuccess() {}

// eslint-disable-next-line @typescript-eslint/no-empty-function
export function onListAclFilteredFailed() {}
